import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!

  return (_openBlock(), _createBlock(_component_ion_buttons, { class: "galidancia-home-logo" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_button, {
        fill: "clear",
        class: "galidancia-home-logo__btn",
        "aria-label": "Ir a inicio",
        onClick: _ctx.goInicio
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: _normalizeClass(["galidancia-home-logo__img", { 'galidancia-home-logo__img--resalta': _ctx.resaltando }]),
            "aria-hidden": "true"
          }, null, 2)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}